// @creds: https://github.com/SkyWalker653/react-fontawesome-icon-picker
import React from "react";
import {
  Button, DropdownToggle, Dropdown, DropdownMenu, Input
} from "reactstrap";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";

library.add(fas);

class ReactIconPicker extends React.PureComponent {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.searchIconHandler = this.searchIconHandler.bind(this);
    this.pickIconHandler = this.pickIconHandler.bind(this);

    this.state = {
      dropdownOpen: false,
      icons: { ...fas },
      iconFull: props.icon,
      pickedIcon: {
        prefix: props.icon && props.icon.includes("fa-") ? props.icon.split(" ")[0] : 'fas',
        iconName: props.icon && props.icon.includes("fa-") ? props.icon.split(" ")[1].replace("fa-", "") : 'list'
      },
      search: ''
    };
  }

  componentDidUpdate() {
      console.log('NEXT PROPS', this.props)
      if (this.state.iconFull != this.props.icon) {
          this.setState({
            iconFull: this.props.icon,
            pickedIcon: {
                prefix: this.props.icon && this.props.icon.includes("fa-") ? this.props.icon.split(" ")[0] : 'fas',
                iconName: this.props.icon && this.props.icon.includes("fa-") ? this.props.icon.split(" ")[1].replace("fa-", "") : 'list'
            }
          })
      }
  }

  toggle() {
    this.setState(prevState => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  }

  searchIconHandler(event) {
    this.setState({
      search: event.target.value
    })
  }

  pickIconHandler(icon) {
    this.toggle()
    this.setState({
      pickedIcon: icon
    })
    this.props.pickIcon(icon)
  }

  render() {
    const { width, height, color, text } = this.props;
    const styles = {
      iconContainer: {
        width: '200px',
        height: '250px',
        overflow: 'scroll',
        padding: '8px'
      },
      iconSearchInput: {
        margin: '0 0 5px 0'
      },
      iconItem: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '6px',
        width: '32px',
        height: '32px',
        borderRadius: '50px',
        fontSize: '18px'
      }
    } 

    const iconLists = Object.keys(this.state.icons)
      .filter(
        key => key !== "faFontAwesomeLogoFull" && this.state.icons[key].iconName.includes(this.state.search)
      )
      .map(key => (
        <Button outline color="secondary" style={styles.iconItem} onClick={() => this.pickIconHandler(this.state.icons[key])} key={key} >
          <FontAwesomeIcon icon={[this.state.icons[key].prefix, this.state.icons[key].iconName]} />
        </Button>
      ));

    return (
        <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
        <DropdownToggle tag="div" style={{ color: this.props.color || '#000'}}>
          <FontAwesomeIcon icon={[this.state.pickedIcon.prefix, this.state.pickedIcon.iconName]} size="lg" />
        </DropdownToggle>
        <DropdownMenu style={styles.iconContainer}>
          <Input type="text" name="icon" placeholder="Search Icon" value={this.state.search}
            onChange={this.searchIconHandler} style={styles.iconSearchInput} />
          { iconLists }
        </DropdownMenu>
      </Dropdown>
    );
  }
}

export default ReactIconPicker;